/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */

import { validateContainers } from './validateContainers';

export function validateActionEvent(event: any): void {
	if (!event) {
		throw new Error('Missing event');
	}

	if (!event.source) {
		throw new Error('Missing event.source');
	}

	if (!event.actionSubject) {
		throw new Error('Missing event.actionSubject');
	}

	if (!event.action) {
		throw new Error('Missing event.action');
	}

	validateContainers(event.containers);
}
